import { Menu, X } from 'lucide-react'
import { useUIStore } from '@store/uiStore'
import { clsx } from 'clsx'

export function MobileHeader() {
  const { sidebarOpen, toggleSidebar } = useUIStore()

  return (
    <header
      className="fixed top-0 left-0 right-0 h-14 z-40 md:hidden"
      style={{
        backgroundColor: 'var(--bg-secondary)',
        borderBottom: '1px solid var(--border-color)'
      }}
    >
      <div className="flex items-center justify-between h-full px-4">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 bg-primary rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-xs">F1</span>
          </div>
          <span className="font-semibold text-sm" style={{ color: 'var(--text-primary)' }}>DealHub</span>
        </div>

        <button
          onClick={toggleSidebar}
          className={clsx(
            'p-2 rounded-md transition-colors',
            'hover:bg-[var(--bg-tertiary)]'
          )}
          style={{ color: 'var(--text-secondary)' }}
          aria-label={sidebarOpen ? 'Close menu' : 'Open menu'}
        >
          {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
    </header>
  )
}
